// "Working progress" — de blokken uit het ontwerp die hun databron nog niet
// hebben (owner-opname 26-08, 0:45: "we can already build in everything related
// to this, but when we click it it just needs to say working progress").
//
// Twee regels die dit project al had, hier samengebracht: de CONTROL staat er
// echt (het ontwerp toont hem, dus de lezer moet hem zien), en bij een klik
// zegt hij in één regel wat hij gaat doen en wat daarvoor nodig is (W8: "geef
// duidelijk aan waarom het niet kan"). Wat er níét meer is: de grijze alinea op
// het scherm zelf die uitlegt wat ontbreekt — dat is bouwverslag, geen inzicht.

import { color, radius, size, weight } from "../tokens";

export type Aanbouw = { titel: string; wordt: string; nodig: string };

/** Wat elk blok uit het ontwerp gaat doen. Eén plek, zodat de tekst niet drift. */
export const AANBOUW: Record<string, Aanbouw> = {
  onderzoek: {
    titel: "Onderzoek bedrijf",
    wordt:
      "Je typt een bedrijfsnaam en krijgt het skill-profiel: welke vaardigheden ze vragen in " +
      "hun vacatures, welke ze in huis hebben, en waar het gat zit.",
    nodig: "de bedrijvenlaan (ontworpen in W4 als de Bedrijfsspiegel, niet gebouwd)",
  },
  vergelijk: {
    titel: "Vergelijk",
    wordt: "Twee vaardigheden, trends of bedrijven naast elkaar, op dezelfde assen.",
    nodig: "een vergelijkweergave; de data eronder staat er wel",
  },
  bedrijven: {
    titel: "Mijn bedrijven",
    wordt:
      "De bedrijven die je volgt, met per bedrijf de stand van hun onderzoek en de " +
      "openstaande signalen.",
    nodig: "een bedrijvenregister en de vacature-extractie",
  },
  nieuwOnderzoek: {
    titel: "Nieuw onderzoek",
    wordt:
      "Een bedrijf toevoegen en de spiegel laten draaien; de beheerder keurt het krediet goed.",
    nodig: "de bedrijvenlaan plus de goedkeurwachtrij (die bestaat al in de leeslaag)",
  },
  onderwerp: {
    titel: "Onderwerp volgen",
    wordt:
      "Je kiest een onderwerp en de feed filtert erop; bij genoeg belangstelling gaat het " +
      "onderwerp zijn eigen bronnen zoeken.",
    nodig: "het gebruikersmodel (W9) — vandaag is er nog geen persoonlijke inlog",
  },
};

export function InAanbouwPaneel({ item, onSluit }: { item: Aanbouw; onSluit: () => void }) {
  return (
    <div
      role="dialog"
      aria-label={`In aanbouw: ${item.titel}`}
      style={{
        position: "fixed",
        left: "50%",
        bottom: 24,
        transform: "translateX(-50%)",
        width: "min(520px, calc(100vw - 32px))",
        background: color.surface,
        border: `1px solid ${color.border}`,
        borderLeft: `3px solid ${color.accentAmber}`,
        borderRadius: radius.block,
        boxShadow: "0 8px 30px rgba(17,24,39,.14)",
        padding: "14px 16px",
        zIndex: 900,
      }}
    >
      <div
        style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "flex-start" }}
      >
        <div>
          <div
            style={{
              fontSize: size.label,
              fontWeight: weight.medium,
              color: color.accentAmber,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: 3,
            }}
          >
            In aanbouw · {item.titel}
          </div>
          <div style={{ fontSize: size.meta, color: color.body, lineHeight: 1.6 }}>{item.wordt}</div>
          <div style={{ fontSize: size.label, color: color.faint, marginTop: 5, lineHeight: 1.5 }}>
            Nodig: {item.nodig}
          </div>
        </div>
        <button
          onClick={onSluit}
          aria-label="Sluiten"
          style={{
            border: "none",
            background: "none",
            color: color.faint,
            cursor: "pointer",
            fontSize: 15,
            fontFamily: "inherit",
            lineHeight: 1,
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}

/** Een knop die er echt uitziet en bij een klik zegt wat hij gaat doen. */
export function AanbouwKnop({
  tekst,
  ico,
  onKlik,
}: {
  tekst: string;
  ico?: string;
  onKlik: () => void;
}) {
  return (
    <button
      onClick={onKlik}
      style={{
        border: `1px solid ${color.border}`,
        borderRadius: 9,
        padding: "10px 12px",
        display: "flex",
        gap: 8,
        alignItems: "center",
        fontSize: 12.5,
        fontWeight: weight.medium,
        color: color.body,
        background: color.surface,
        cursor: "pointer",
        fontFamily: "inherit",
        textAlign: "left",
      }}
    >
      {ico && <span aria-hidden>{ico}</span>}
      {tekst}
    </button>
  );
}
